export default __webpack_public_path__ + "static/bannerPubliMB-f9cd93b54998f2037df36a5a52a3afdf.png";